import axios from '../config/axios';

export default async function fetchUsage(token) {
  const response = await axios.get('/users/usage', {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data;
}
